<template>
    <div>
        <div class="flex items-center justify-between lg:px-3">
            <div class="flex items-center">
                <facebook-icon v-if="provider === 'facebook'" class="mr-3 w-7 h-7" />
                <google-icon v-if="provider === 'google'" class="mr-3 w-7 h-7" />
                <twitter-icon v-if="provider === 'twitter'" class="mr-3 w-7 h-7" />
                <Linked-in-icon v-if="provider === 'linkedin'" class="mr-3 w-7 h-7" />
                <github-icon v-if="provider === 'github'" class="mr-3 w-7 h-7" />
                <git-lab-icon v-if="provider === 'gitlab'" class="mr-3 w-7 h-7" />
                <bitbucket-icon v-if="provider === 'bitbucket'" class="mr-3 w-7 h-7" />

                <div>
                    <div class="text-gray-600 text-sm font-semibold">
                        {{ provider.charAt(0).toUpperCase() + provider.slice(1) }}
                    </div>

                    <div v-if="createdAt !== null" class="text-gray-500 text-xs">Connected {{ createdAt }}</div>

                    <div v-else class="text-gray-500 text-xs">Not connected</div>
                </div>
            </div>

            <slot name="action"></slot>
        </div>
    </div>
</template>

<script>
import FacebookIcon from "@/ProviderIcons/FacebookIcon"
import GoogleIcon from "@/ProviderIcons/GoogleIcon"
import TwitterIcon from "@/ProviderIcons/TwitterIcon"
import LinkedInIcon from "@/ProviderIcons/LinkedInIcon"
import GithubIcon from "@/ProviderIcons/GithubIcon"
import GitLabIcon from "@/ProviderIcons/GitLabIcon"
import BitbucketIcon from "@/ProviderIcons/BitbucketIcon"

export default {
    props: {
        provider: String,
        createdAt: {
            type: String,
            default: null,
        },
    },

    components: {
        FacebookIcon,
        GoogleIcon,
        TwitterIcon,
        LinkedInIcon,
        GithubIcon,
        GitLabIcon,
        BitbucketIcon,
    },
}
</script>
